
  <template>
    <div id="wrapper" :key="valuekey">
        <div class="col-xl-12">
            <div class="card-box">

               <div class="form-row">
                    
                    <div class="form-group col-md-1">
                        <br>
                        <label class="col-form-label"> 
                            <code class="highlighter-rouge">*</code> {{$t('string.msg.date.begin.placeholder')}}
                        </label>
                    </div>

                    <div class="form-group col-md-1">
                        <label class="col-form-label"> 
                            {{$t('string.msg.date.begin.day')}}
                        </label>
                         <select id="dayBegin" v-model="dayBegin" class="form-control">
                             <option :value="item.day" v-bind:key="item.day" v-for="item in daysBegin">{{item.day}}</option>
                        </select>
                    </div>

                    <div class="form-group col-md-1">
                        <label class="col-form-label"> 
                            {{$t('string.msg.date.begin.month')}}
                        </label>
                         <select id="monthBegin" v-model="monthBegin" @change="daysInMonthBegin(monthBegin,yearBegin)"  class="form-control">
                            <option :value="Number(0)" > {{$t('string.msg.date.begin.jan')}}</option>
                            <option :value="Number(1)" > {{$t('string.msg.date.begin.feb')}}</option>
                            <option :value="Number(2)" > {{$t('string.msg.date.begin.mar')}}</option>
                            <option :value="Number(3)" > {{$t('string.msg.date.begin.apr')}}</option>
                            <option :value="Number(4)" > {{$t('string.msg.date.begin.may')}}</option>
                            <option :value="Number(5)" > {{$t('string.msg.date.begin.jun')}}</option>
                            <option :value="Number(6)" > {{$t('string.msg.date.begin.jul')}}</option>
                            <option :value="Number(7)" > {{$t('string.msg.date.begin.aug')}}</option>
                            <option :value="Number(8)" > {{$t('string.msg.date.begin.sep')}}</option>
                            <option :value="Number(9)" > {{$t('string.msg.date.begin.oct')}}</option>
                            <option :value="Number(10)" > {{$t('string.msg.date.begin.nov')}}</option>
                            <option :value="Number(11)" > {{$t('string.msg.date.begin.dec')}}</option>

                        </select>

                    </div>
                    <div class="form-group col-md-1">
                        <label class="col-form-label"> 
                            {{$t('string.msg.date.begin.year')}}
                        </label>
                         <select v-model="yearBegin" class="form-control">
                           <option :value="2019" selected> {{$t('2019')}}</option>
                           <option :value="2020" > {{$t('2020')}}</option>
                           <option :value="2021" > {{$t('2021')}}</option>
                        </select>

                    </div>
                </div>

                <div class="form-row">
    
                    <div class="form-group col-md-1">
                        <br>
                        <label class="col-form-label"> 
                            <code class="highlighter-rouge">*</code> {{$t('string.msg.date.end.placeholder')}}
                        </label>
                    </div>

                    <div class="form-group col-md-1">
                        <label class="col-form-label"> 
                            {{$t('string.msg.date.begin.day')}}
                        </label>
                         <select id="dayBegin" v-model="dayEnd" class="form-control">
                             <option :value="item.day" v-bind:key="item.day" v-for="item in daysEnd">{{item.day}}</option>
                        </select>

                    </div>
                    <div class="form-group col-md-1">
                        <label class="col-form-label"> 
                            {{$t('string.msg.date.begin.month')}}
                        </label>
                        <select id="monthEnd" v-model="monthEnd" @change="daysInMonthEnd(monthEnd,yearEnd)"  class="form-control">
                            <option :value="Number(0)" > {{$t('string.msg.date.begin.jan')}}</option>
                            <option :value="Number(1)" > {{$t('string.msg.date.begin.feb')}}</option>
                            <option :value="Number(2)" > {{$t('string.msg.date.begin.mar')}}</option>
                            <option :value="Number(3)" > {{$t('string.msg.date.begin.apr')}}</option>
                            <option :value="Number(4)" > {{$t('string.msg.date.begin.may')}}</option>
                            <option :value="Number(5)" > {{$t('string.msg.date.begin.jun')}}</option>
                            <option :value="Number(6)" > {{$t('string.msg.date.begin.jul')}}</option>
                            <option :value="Number(7)" > {{$t('string.msg.date.begin.aug')}}</option>
                            <option :value="Number(8)" > {{$t('string.msg.date.begin.sep')}}</option>
                            <option :value="Number(9)" > {{$t('string.msg.date.begin.oct')}}</option>
                            <option :value="Number(10)" > {{$t('string.msg.date.begin.nov')}}</option>
                            <option :value="Number(11)" > {{$t('string.msg.date.begin.dec')}}</option>
                        </select>
                    </div>

                    <div class="form-group col-md-1">
                        <label class="col-form-label"> 
                            {{$t('string.msg.date.begin.year')}}
                        </label>
                         <select v-model="yearEnd" class="form-control">
                           <option :value="2019" selected> {{$t('2019')}}</option>
                           <option :value="2020" > {{$t('2020')}}</option>
                           <option :value="2021" > {{$t('2021')}}</option>
                        </select>
                    </div>
                    
                    <div class="form-group col-md-3">
                        <label class="col-form-label"><strong>{{$t('string.msg.dashboard.orders.select.status.label')}}</strong> </label>
                        <select v-model="filters.statusOrder" @change="onChange()"  class="form-control">
                            <option :value="null" selected> {{$t('string.msg.dashboard.orders.select.status.all')}}</option>
                            <option value="WAITING_FOR_RESPONSE"> {{$t('string.msg.dashboard.orders.table.status.waiting')}}</option>
                            <option value="IN_PROGRESS"> {{$t('string.msg.dashboard.orders.table.status.progress')}}</option>
                            <option value="CLOSED"> {{$t('string.msg.dashboard.orders.table.status.closed')}}</option>
                            <option value="PAID"> {{$t('string.msg.dashboard.orders.table.status.paid')}}</option>
                        </select>
                    </div>


                    <div class="form-group col-md-3"></div>

                    <div class="form-group col-md-2" v-if="items">
                        <h4 class="text-center">{{$t('str.total')}}</h4>
                        <h4 class="text-center" style="color:grey">{{items.length}}</h4>
                    </div>

                </div>
                <br>
                  <br/>
                     <div class="form-row">
                        <div class="form-group col-md-6 text-center">
                            <button @click="checkForm()" class="btn btn-success w-100">{{$t('string.msg.form.btn.search')}}</button>
                        </div>
                        <div class="form-group col-md-5 text-right">
                            <download-excel v-if="items.length>0"
                                    class   = "btn btn-primary"
                                    :fetch   = "fetchData"
                                    :fields = "json_fields"
                                    :meta = "json_meta"
                                    type    = "csv"
                                    name    = "parts-history.xls">
                                    Download CSV
                            </download-excel>
                        </div>
                    </div>
                      

                <div v-if="items.length==0" class="card text-center">
                    <div class="card-body">
                        <h5 class="card-title">{{$t('string.msg.dashboard.no.orders')}}</h5>
                        <p class="card-text">{{$t('string.msg.dashboard.no.orders.description')}}</p>
                    </div>
                </div>

                <div v-if="items.length>0" class="table-responsive">
                    <table class="table table-centered table-hover mb-0" id="datatable">
                        <thead>
                            <tr>
                                <th class="border-top-0"></th>
                                <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.trucker.title')}}</th>
                                <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.manucfacturer.title')}}</th>
                                <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.family.title')}}</th>
                                <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.for.title')}}</th>
                                <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.date.title')}}</th>
                                <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.status.title')}}</th>
                                <th class="border-top-0"></th>
                            </tr>
                        </thead>
                        <tbody v-bind:key="item._id" v-for="item in items" class="cursor-pointer">
                            <tr v-if="item">
                                <td>
                                    <span v-if="item.isSearchByCompany && item.isSearchByCompany == true">
                                        <i class="dripicons-store"></i>
                                    </span>
                                    <span v-else>
                                        <i class="dripicons-user"></i>
                                    </span>
                                </td>
                                 <td>
                                    <span>
                                        {{`${camelize(item.systemUser.firstName)} ${camelize(item.systemUser.lastName)}`}}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.manufacturer">
                                        {{camelize(item.manufacturer.name)}}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.family">
                                        {{camelize(item.family.name)}}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.manufacturer && item.manufacturer.type=='TRUCK'">
                                        {{toUpperCase($t('string.msg.truck.name'))}}
                                    </span>
                                    <span v-if="item.manufacturer && item.manufacturer.type=='TRUCK_TRAILER'">
                                        {{toUpperCase($t('string.msg.trucktrailer.name'))}}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.orders[0] && item.orders[0].dateOrder">
                                         {{new Date(item.orders[0].dateOrder).toLocaleDateString()}} - {{new Date(item.orders[0].dateOrder).toLocaleTimeString()}}
                                    </span>
                                </td>
                                 <td>
                                    <span class="status-order" v-if="item.statusOrder.toUpperCase() == 'WAITING_FOR_RESPONSE'" style="background-color:#fabc2a; color:black">
                                        &nbsp;&nbsp;&nbsp; {{$t(item.statusOrder.toUpperCase())}}&nbsp;&nbsp;&nbsp;
                                    </span>
                                    <span class="status-order" v-if="item.statusOrder.toUpperCase() == 'CLOSED'"  style="background-color:gray; color:white">
                                       &nbsp;&nbsp; &nbsp; {{$t(item.statusOrder.toUpperCase())}}&nbsp; &nbsp;&nbsp;
                                    </span>
                                    <span class="status-order" v-if="item.statusOrder.toUpperCase() == 'PAID'" style="background-color:green; color:white">
                                      &nbsp;&nbsp; &nbsp; {{$t(item.statusOrder.toUpperCase())}}&nbsp; &nbsp;&nbsp;
                                    </span>
                                    <span class="status-order" v-else-if="item.statusOrder.toUpperCase() == 'IN_PROGRESS'" style="background-color:blue; color:white">
                                       &nbsp;&nbsp; &nbsp; {{$t(item.statusOrder.toUpperCase())}}&nbsp; &nbsp;&nbsp;
                                    </span>
                                </td>
                                <td>
                                    <button @click="selectItem(item)" class="btn btn-danger w-100">{{$t('string.msg.dashboard.orders.btn.view')}}</button>
                                </td>
                                
                            </tr>
                        </tbody>
                    </table>
                </div>
                 <div v-if="errors.length" class="alert alert-danger">
                    <p class="lead">{{$t('response.msg.error.empty.fields')}}</p>
                    <ul>
                        <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                    </ul>
                </div>
            </div>
        </div>
        <ModalParts :order="order" :trucks="trucks"/>
    </div>
</template>

<script>
import Controller from './CrtListOrdersParts';
import ModalParts from './Modal/ModalOrderPart';

export default {
  name: 'ListOrdersParts',
  props: ["valuekey"],
  watch:{
        'valuekey'(){
    }
  },
  components: {
    ModalParts,
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        items: [],
        trucks:null,
        order:null,
        companies:[],
        nDays:1,
        orderSelected: null,
         dayBegin: null,
        monthBegin: null,
        yearBegin: null,
        dayEnd: null,
        monthEnd: null,
        yearEnd: null,
        daysBegin:[{day: null}],
        daysEnd: [{day: null}],
        filters: {
            typeOrder: "PARTS",
            statusOrder: null,
            beginDate: null,
            endDate: null
        },
        data:{
            total: null
        },
         json_fields: {
            'Tipo': 'typeOrder',   
            'Fabricante': 'manufacturer.name',
            'Familia': 'family.name',
            'Descricao':'description',
            'Data': 'dateOrder',
            'Status': 'statusOrder',
            'Caminhoneiro': 'systemUser.firstName',
            'Email': 'systemUser.email',
            'Telefone': 'systemUser.primaryPhone',
        },
        json_data: [
            {
                typeOrder: null,
                manufacturer:{
                    name: null
                },
                family:{
                    name: null
                },
                description: null,
                Data: null,
                Status: null,
                systemUser:{
                    firstName: null,
                    email: null,
                    primaryPhone: null
                },
               
            },
        ],
        json_meta: [
			[{
				"key": "charset",
				"value": "utf-8"
			}]
		],
        totalOrders: 0,
        newOrder: false
      }
  },
  methods: Controller.methods,
  created() {
  },
  mounted(){
      Controller.init(this);
  }
 
}
</script>
<style>
</style>
